import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Static_pg_meta, Update_Static_pg_meta } from "../services/staticPgMetaServices";

const initialState = {
  getStaticPgMetaState: [],
  isLoading: false,
};

export const GetStaticPgMeta = createAsyncThunk(
  "/getStaticPgMeta",
  async (payload) => {
    return await Static_pg_meta(payload);
  }
);
export const UpdateStaticPgMeta = createAsyncThunk(
  "/updateStaticPgMeta",
  async (payload) => {
    return await Update_Static_pg_meta(payload);
  }
);

const staticPgMetaSlice = createSlice({
  name: "staticPgMetaSlice",
  initialState,
  reducers: {
    clearPgMeta: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(GetStaticPgMeta.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(GetStaticPgMeta.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getStaticPgMetaState = action.payload;
    });
    builder.addCase(GetStaticPgMeta.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});
export default staticPgMetaSlice.reducer;
export const { clearPgMeta } = staticPgMetaSlice.actions;

export const selectPgWebHookState = (state) => {
  return state.staticPgMeta.getStaticPgMetaState;
};

export const useStaticPgMeta = () => {
  const getStaticPgMetaState = useSelector(selectPgWebHookState);
  return useMemo(() => getStaticPgMetaState, [getStaticPgMetaState]);
};
